<rid-recognize-shortest-form
  class="h-dvh"
  [assignments]="[
    ['ge', 'hoor', 'zaam'],
    [undefined, 'aap', 'je'],
    ['ver', 'werk', 'en'],
  ]"
  (finished)="$router.navigate(['/mechanics/morphemes'])"
/>
